import { nullable } from '@abb-procure/api';
import * as t from 'io-ts';

const SearchHierarchyElementDto = t.type(
  {
    name: nullable(t.string),
    entity_number: nullable(t.string),
    entity_type: nullable(t.string),
    order_index: nullable(t.number),
  },
  'SearchRequest',
);

type SearchHierarchyElementDto = t.TypeOf<typeof SearchHierarchyElementDto>;
export { SearchHierarchyElementDto };
